export default __webpack_public_path__ + "static/media/p-chart-2.0a6d4514.jpg";